import PropTypes from 'prop-types'

export const childrenPropType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
export const stylePropType = PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.oneOf([false])])
